import CalendarProcessingOptions from 'owa-service/lib/contract/CalendarProcessingOptions';
import { getCalendarOptions } from 'owa-calendar-processing-configuration';
import getForwardMeetingNotificationOption from '../selectors/getForwardMeetingNotificationOption';
import getOldMeetingMessgeOption from '../selectors/getOldMeetingMessageOption';

/**
 * Returns true if there is a change in the event options
 */

export default function isInvitationOptionDirty(): boolean {
    let calendarProcessingConfiguration: CalendarProcessingOptions = getCalendarOptions();

    if (!calendarProcessingConfiguration) {
        return false;
    }

    let oldMeetingMessagesStatus = getOldMeetingMessgeOption();
    let forwardedMeetingNotificationsStatus = getForwardMeetingNotificationOption();

    return (
        oldMeetingMessagesStatus !== calendarProcessingConfiguration.RemoveOldMeetingMessages ||
        forwardedMeetingNotificationsStatus !==
            calendarProcessingConfiguration.RemoveForwardedMeetingNotifications
    );
}
